<template>
  <div class="page-register">
    <!-- <div class="page-header">
      <span class="page-header-text">车辆登记</span>
    </div> -->
    <div class="form">
      <van-form @submit="onSubmit">
        <div class="form-wrap">
          <van-field
            v-model="form.licensePlateNumber"
            name="licensePlateNumber"
            placeholder="请输入车牌号"
            input-align="right"
            error-message-align="right"
            :rules="[{ required: true, message: '' }]"
          >
            <div slot="label" class="input-label">车牌号</div>
          </van-field>
          <van-field
            v-model="form.name"
            name="name"
            input-align="right"
            placeholder="请输入人员姓名"
            error-message-align="right"
            :rules="[{ required: true, message: '' }]"
          >
            <div slot="label" class="input-label">人员姓名</div>
          </van-field>
          <van-field
            v-model="form.phone"
            type="tel"
            name="phone"
            input-align="right"
            maxlength="11"
            placeholder="请输入手机号码"
            error-message-align="right"
            :rules="[{ required: true, message: '' }]"
          >
            <div slot="label" class="input-label">手机号码</div>
          </van-field>
          <van-field
            v-model="form.visitingPurpose"
            name="visitingPurpose"
            input-align="right"
            placeholder="请输入到访目的"
            error-message-align="right"
            :rules="[{ required: true, message: '' }]"
          >
            <div slot="label" class="input-label">到访目的</div>
          </van-field>
          <van-field
            v-model="form.visitingAddress"
            name="visitingAddress"
            input-align="right"
            placeholder="请输入到访地址"
            error-message-align="right"
            :rules="[{ required: true, message: '' }]"
          >
            <div slot="label" class="input-label">到访地址</div>
          </van-field>
          <van-field
            v-model="form.visitingTime"
            name="visitingTime"
            input-align="right"
            placeholder="请输入到访时间"
            error-message-align="right"
            :is-link="true"
            :readonly="true"
            :rules="[{ required: true, message: '' }]"
            @click="showCalendar = true"
          >
            <div slot="label" class="input-label">到访时间</div>
          </van-field>
        </div>
        <van-field
          name="imageUrl"
          class="upload"
        >
          <div slot="label" class="input-label">请备注和上传图片/视频</div>
          <div slot="input" class="input">
            <van-field
              v-model="form.remarks"
              rows="2"
              maxlength="200"
              show-word-limit	
              autosize
              type="textarea"
              placeholder="请输入备注"
            />
            <van-uploader v-model="imageUrl" accept="video/*,image/*" :max-count="6" :preview-size="71" :after-read="afterRead" @click="deleteImg"/>
          </div>
        </van-field>
        <div>
          <van-button class="submit-btn" round type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </div>
    <van-calendar v-model="showCalendar" @confirm="confirmCalendar" />
  </div>
</template>

<script>
import Vue from 'vue'
import { Dialog, Toast, Form, Field, Button, Calendar, Popup, Picker, Uploader } from 'vant'
Vue.use(Dialog)
Vue.use(Toast)
Vue.use(Form)
Vue.use(Field)
Vue.use(Button)
Vue.use(Calendar)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Uploader)
import { NetService } from '@/service'
export default {
  data() {
    return {
      form: {
        name: '', // 来访人姓名
        phone: undefined, // 电话号码
        projectId: '', // 项目id
        licensePlateNumber: '', // 车牌号
        visitingAddress: '', // 到访地址
        visitingPurpose: '', // 到访目的
        visitingTime: '', // 到访时间
        imageUrl: [],
        remarks: ''
      },
      imageUrl: [],
      showCalendar: false,
      isLoading: false
    }
  },
  created() {
    this.form.projectId = this.$route.query.projectId || ''
  },
  methods: {
    onSubmit() {
      // 防止重复提交
      if (this.imageUrl.length !== this.form.imageUrl.length) return
      if (!this.isLoading) {
        this.isLoading = true
        let loading = Toast.loading({ duration: 0, message: '正在提交...' })
          NetService.Carsarchiv(this.form).then(() => {
            loading.clear()
            this.isLoading = false
            Toast({ duration: 2000, message: '已登记成功！' })
            this.form = {
              name: '', // 来访人姓名
              phone: undefined, // 电话号码
              projectId: this.$route.query.projectId, // 项目id
              licensePlateNumber: '', // 车牌号
              visitingAddress: '', // 到访地址
              visitingPurpose: '', // 到访目的
              visitingTime: '', // 到访时间
              imageUrl: [],
              remarks: ''
            }
            this.imageUrl = []

          }).catch((err) => {
            this.isLoading = false
            Toast({ duration: 2000, message: err.msg })
            // loading.clear()
          })
      }
      // setTimeout(()=>{
      //     this.isLoading = false
      // }, 1000)
    },
    confirmPicker(val) {
      // console.log(val, index)
      this.form.sex = val.id
      this.form.sexLabel = val.text
      this.showPicker = false
    },
    confirmCalendar(val) {
      const month = val.getMonth() + 1 < 10 ? '0' + (val.getMonth() + 1) : (val.getMonth() + 1)
      const day = val.getDate() < 10 ? '0' + val.getDate() : val.getDate()
      this.form.visitingTime = `${val.getFullYear()}-${month}-${day}`
      this.showCalendar = false
    },
    afterRead(file) {
      let loading = Toast.loading({ duration: 0, message: '正在上传文件...' })
      const formData = new FormData()
      formData.append('file', file.file)
      NetService.ImageUpload(formData).then(res => {
        loading.clear()
        this.form.imageUrl.push({
          url: res.url,
          name: res.originalFileName,
          id: res.id
        })
      })
    },
    deleteImg(e, i) {
      this.form.imageUrl.splice(i.index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.page-register {
  background: #F6F6F6;
  height: 100vh;
  position: relative;
  .page-header {
    height: 80px;
    padding: 0 12px;
    @extend .flex-row;
    align-items: center;
    background: #fff;
    text-align: center;
    &-text {
      flex: 1;
      @include text(15px, bold, $color-black);
    }
  }
  .form {
    padding: 20px;
    border-radius: 12px;
    height: calc(100vh - 76px - 64px - 40px);
    overflow: auto;
    .form-wrap {
      padding-bottom: 20px;
      background: #fff;
      border-radius: 12px;
      overflow: hidden;
    }
    .input-label {
      color: #000;
      font-size: 24px;
    }
    .upload {
      margin-top: 20px;
      border-radius: 12px;
      margin-bottom: 20px;
      display: block;
      .input-label {
        margin-bottom: 30px;
        font-size: 20px;
        color: #000;
        width: 300px;
      }
      .input {
        width: 100%;
        background: #FAFAFA;
        border-radius: 6px 6px 6px 6px;
        .van-cell {
          background: #FAFAFA;
        }
        .van-uploader__upload {
          border: 1px dashed #9B9B9B;
        }
      }
    }
  }
}
.submit-btn {
  width: calc(100vw - 40px);
  display: block;
  height: 76px;
  background: #FF8B5C;
  border-radius: 12px 12px 12px 12px;
  border: none;
  position: fixed; 
  bottom: 64px;
  left: 0;
  right: 0;
  margin: 0 20px;
  font-size: 24px;
}
</style>